import { render, staticRenderFns } from "./Survey.vue?vue&type=template&id=0ace6e44&scoped=true"
import script from "./Survey.vue?vue&type=script&lang=js"
export * from "./Survey.vue?vue&type=script&lang=js"
import style0 from "./Survey.vue?vue&type=style&index=0&id=0ace6e44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ace6e44",
  null
  
)

export default component.exports